'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dateFns = require('date-fns');

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


var atob = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

var base64_url_decode = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

var lib = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

var InvalidTokenError_1 = InvalidTokenError;
lib.InvalidTokenError = InvalidTokenError_1;

var SEVERITY = {
    Message: 'message',
    Warning: 'warning',
    Error: 'error'
};

var loggers = {
    Console: 'console'
};

var trackers = {
    NewRelic: 'newrelic'
};

var currentSetup = [];
var valuesApplied = [];

var setup = function setup(trackers) {
    if (currentSetup.length !== 2) {
        currentSetup = [loggers.Console, trackers.NewRelic];
    }
};

var apply = function apply(key, value) {
    valuesApplied[key] = value;

    if (currentSetup.some(function (l) {
        return l === trackers.NewRelic;
    })) {
        applyNewRelic(key, value);
    }
};

var applyNewRelic = function applyNewRelic(key, value) {
    if (window && window.newrelic) {
        window.newrelic.setCustomAttribute(key, value || '');
    }
};

var action = function action(severity, message, obj) {
    if (currentSetup.some(function (l) {
        return l === loggers.Console;
    })) {
        actionConsole(severity, message);
    }

    if (currentSetup.some(function (l) {
        return l === trackers.NewRelic;
    })) {
        actionNewRelic(severity, message, obj);
    }
};

var actionConsole = function actionConsole(severity, message, obj) {
    switch ((severity || SEVERITY.Message).toLowerCase()) {
        case SEVERITY.Error:
            console.error(message, obj);
            break;
        case SEVERITY.Warning:
            console.warn(message, obj);
            break;
        case SEVERITY.Message:
        default:
            console.log(message, obj);
            break;
    }
};

var actionNewRelic = function actionNewRelic(severity, message, obj) {
    if (window && window.newrelic) {
        window.newrelic.addPageAction(message, obj);
    }
};

var DuLogger = {
    Setup: setup,
    Apply: apply,
    Action: action,
    log: function log(message, obj) {
        action(SEVERITY.Message, message, obj);
    },
    warn: function warn(message, obj) {
        action(SEVERITY.Warn, message, obj);
    },
    error: function error(message, obj) {
        action(SEVERITY.Error, message, obj);
    },
    SEVERITY: SEVERITY,
    Loggers: loggers,
    Trackers: trackers
};

var GetTokenFromAuth = function GetTokenFromAuth(auth) {
    if (typeof auth !== 'string') {
        return null;
    }

    return auth.includes('Bearer ') || auth.includes('Basic ') ? auth.split(' ')[1] : auth;
};

var GetGroups = function GetGroups(token) {
    var decodedToken = DecodeToken(token);

    if (window && window.newrelic) {
        window.newrelic.setCustomAttribute('OktaUserId', decodedToken.uid || '');
    }

    return decodedToken.groups || [];
};

var IsInGroup = function IsInGroup(token, allowedGroups) {
    var groups = GetGroups(token);
    return groups.some(function (group) {
        return allowedGroups.indexOf(group) >= 0;
    });
};

var GetEmail = function GetEmail(token) {
    var decodedToken = DecodeToken(token);
    return decodedToken.sub || decodedToken.email || '';
};

var GetOktaId = function GetOktaId(token) {
    var decodedToken = DecodeToken(token);
    return decodedToken.uid || '';
};

var GetUserId = function GetUserId(token) {
    var decodedToken = DecodeToken(token);
    var email = decodedToken.sub || decodedToken.email || '';

    if (email.length > 0) {
        return email.substr(0, email.indexOf('@'));
    }

    return null;
};

var GetExpireDate = function GetExpireDate(token) {
    var decodedToken = DecodeToken(token);
    var exp = decodedToken.exp || 0;

    if (exp > 0) {
        return new Date(exp * 1000);
    }

    return null;
};

var IsTokenValid = function IsTokenValid(token, gracePeriodInMinutes) {
    var expDate = GetExpireDate(token);

    if (expDate === null) {
        return false;
    }

    var difference = expDate - new Date();

    if (difference < gracePeriodInMinutes * 60000) {
        return false;
    }

    return true;
};

var DecodeToken = function DecodeToken(token) {
    var decodedToken = {};

    try {
        decodedToken = lib(token);
    } catch (error) {
        DuLogger.warn('Found an invalid token, this is only okay if we are logging a user out or give them a not authorized page.', token);
    }

    return decodedToken;
};

var GetGroupScope = function GetGroupScope(location) {
    var environment = '';
    var hostname = location ? location : window ? window.location.hostname.toLowerCase() : '';

    if (hostname.includes('dev') || hostname.includes('localhost')) {
        environment = 'dev';
    } else if (hostname.includes('stage')) {
        environment = 'stage';
    } else if (hostname.includes('uat')) {
        environment = 'uat';
    } else if (hostname.includes('qa')) {
        environment = 'qa';
    } else if (hostname.includes('tst') || hostname.includes('test')) {
        environment = 'test';
    } else {
        environment = 'prod';
    }

    return environment;
};

var ValidateTokenWithWriteScope = function ValidateTokenWithWriteScope(context, token, adminGroups, regularGroups) {
    if (!token || token.length <= 0) {
        if (context.state.canWrite === null || context.state.canWrite === true) {
            context.setState({ canWrite: false });
        }

        return false;
    }

    if (window && window.newrelic) {
        window.newrelic.setCustomAttribute('OktaUserId', GetOktaId(token));
    }

    adminGroups = adminGroups ? adminGroups : window && window.config ? window.config.OKTA_ADMIN_GROUPS || [] : [];
    regularGroups = regularGroups ? regularGroups : window && window.config ? window.config.OKTA_REGULAR_GROUPS || [] : [];

    if (IsInGroup(token, adminGroups) || IsInGroup(token, regularGroups)) {
        if (context.state.canWrite === null || context.state.canWrite === false) {
            context.setState({ canWrite: true });
        }
    } else {
        if (context.state.canWrite === null || context.state.canWrite === true) {
            context.setState({ canWrite: false });
        }
    }

    return true; //Return true because token is valid, don't care about canWrite for the return
};

var DuAuthenticationUtilities = {
    OnAuthRequired: function OnAuthRequired(_ref) {
        var history = _ref.history;
        return history.push('/');
    },
    GetTokenFromAuth: GetTokenFromAuth,
    GetGroups: GetGroups,
    IsInGroup: IsInGroup,
    GetEmail: GetEmail,
    GetOktaId: GetOktaId,
    GetUserId: GetUserId,
    GetGroupScope: GetGroupScope,
    GetExpireDate: GetExpireDate,
    IsTokenValid: IsTokenValid,
    DecodeToken: DecodeToken,
    ValidateTokenWithWriteScope: ValidateTokenWithWriteScope
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var _this = undefined;

var CACHE_CONFIG_KEY = 'cacheSettings';
var SESSION_KEY = '_session';
var LOG_KEY = 'DU_CACHE:: ';

var configLoaded = false;

var cacheSettings = {
    lifespanInMilliseconds: 3600000,
    cacheVersion: process.env.REACT_APP_VERSION,
    cacheKeys: []
};

var defaultCacheFunc = function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        DuLogger.error(LOG_KEY + 'Not Setup!!!');

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function defaultCacheFunc() {
        return _ref.apply(this, arguments);
    };
}();

var cacheGlobal = !!window ? window : global;

var setPermanentMethod = cacheGlobal && cacheGlobal.localStorage ? function () {
    var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, value) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        cacheGlobal.localStorage.setItem(key, value);

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function (_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}() : defaultCacheFunc;
var readPermanentMethod = cacheGlobal && cacheGlobal.localStorage ? function () {
    var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(key) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        return _context4.abrupt('return', new Promise(function () {
                            var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve) {
                                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                resolve(cacheGlobal.localStorage.getItem(key));

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this);
                            }));

                            return function (_x4) {
                                return _ref4.apply(this, arguments);
                            };
                        }()));

                    case 1:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function (_x3) {
        return _ref3.apply(this, arguments);
    };
}() : defaultCacheFunc;
var deletePermanentMethod = cacheGlobal && cacheGlobal.localStorage ? function () {
    var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(key) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        cacheGlobal.localStorage.removeItem(key);

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    return function (_x5) {
        return _ref5.apply(this, arguments);
    };
}() : defaultCacheFunc;

var setTemporaryMethod = cacheGlobal && cacheGlobal.sessionStorage ? function () {
    var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(key, value) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        cacheGlobal.sessionStorage.setItem(key, value);

                    case 1:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, _this);
    }));

    return function (_x6, _x7) {
        return _ref6.apply(this, arguments);
    };
}() : defaultCacheFunc;
var readTemporaryMethod = cacheGlobal && cacheGlobal.sessionStorage ? function () {
    var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(key) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        return _context8.abrupt('return', new Promise(function () {
                            var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(resolve) {
                                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                                    while (1) {
                                        switch (_context7.prev = _context7.next) {
                                            case 0:
                                                resolve(cacheGlobal.sessionStorage.getItem(key));

                                            case 1:
                                            case 'end':
                                                return _context7.stop();
                                        }
                                    }
                                }, _callee7, _this);
                            }));

                            return function (_x9) {
                                return _ref8.apply(this, arguments);
                            };
                        }()));

                    case 1:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, _this);
    }));

    return function (_x8) {
        return _ref7.apply(this, arguments);
    };
}() : defaultCacheFunc;
var deleteTemporaryMethod = cacheGlobal && cacheGlobal.sessionStorage ? function () {
    var _ref9 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(key) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        cacheGlobal.sessionStorage.removeItem(key);

                    case 1:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, _this);
    }));

    return function (_x10) {
        return _ref9.apply(this, arguments);
    };
}() : defaultCacheFunc;

var cacheIsSetup = cacheGlobal && cacheGlobal.localStorage && cacheGlobal.sessionStorage;

var setupCache = function () {
    var _ref10 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(setPermanentFunc, readPermanentFunc, deletePermanentFunc, setTemporaryFunc, readTemporaryFunc, deleteTemporaryFunc) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        if (!setTemporaryFunc) {
                            setTemporaryFunc = setPermanentFunc;
                        }

                        if (!readTemporaryFunc) {
                            readTemporaryFunc = readPermanentFunc;
                        }

                        if (!deleteTemporaryFunc) {
                            deleteTemporaryFunc = deletePermanentFunc;
                        }

                        if (!(!verifyFunction(setPermanentFunc) || !verifyFunction(readPermanentFunc) || !verifyFunction(deletePermanentFunc) || !verifyFunction(setTemporaryFunc) || !verifyFunction(readTemporaryFunc) || !verifyFunction(deleteTemporaryFunc))) {
                            _context10.next = 7;
                            break;
                        }

                        cacheIsSetup = false;
                        DuLogger.error(LOG_KEY + 'Unable to find a required function for cache to function. No cache can be saved!');
                        return _context10.abrupt('return');

                    case 7:

                        setPermanentMethod = setPermanentFunc;
                        readPermanentMethod = readPermanentFunc;
                        deletePermanentMethod = deletePermanentFunc;

                        setTemporaryMethod = setTemporaryFunc;
                        readTemporaryMethod = readTemporaryFunc;
                        deleteTemporaryMethod = deleteTemporaryFunc;

                        _context10.next = 15;
                        return configure();

                    case 15:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, _this);
    }));

    return function setupCache(_x11, _x12, _x13, _x14, _x15, _x16) {
        return _ref10.apply(this, arguments);
    };
}();

var verifyFunction = function () {
    var _ref11 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(func) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        if (!(typeof func !== 'function')) {
                            _context11.next = 2;
                            break;
                        }

                        return _context11.abrupt('return', false);

                    case 2:
                        return _context11.abrupt('return', true);

                    case 3:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, _this);
    }));

    return function verifyFunction(_x17) {
        return _ref11.apply(this, arguments);
    };
}();

var configure = function () {
    var _ref12 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var cachedSettingsString, cachedSettings;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        if (!(!configLoaded && cacheIsSetup)) {
                            _context12.next = 19;
                            break;
                        }

                        _context12.next = 3;
                        return readPermanentMethod(CACHE_CONFIG_KEY);

                    case 3:
                        _context12.t0 = _context12.sent;

                        if (_context12.t0) {
                            _context12.next = 6;
                            break;
                        }

                        _context12.t0 = '';

                    case 6:
                        cachedSettingsString = _context12.t0;

                        if (!(cachedSettingsString.length <= 0)) {
                            _context12.next = 10;
                            break;
                        }

                        configLoaded = true;
                        return _context12.abrupt('return');

                    case 10:
                        cachedSettings = JSON.parse(cachedSettingsString);

                        if (!cachedSettings) {
                            _context12.next = 16;
                            break;
                        }

                        cacheSettings = cachedSettings;

                        if (process.env.REACT_APP_VERSION !== cacheSettings.cacheVersion) {
                            clearAllCache();
                            cacheSettings.cacheVersion = process.env.REACT_APP_VERSION;
                        }
                        _context12.next = 18;
                        break;

                    case 16:
                        _context12.next = 18;
                        return setPermanentMethod(CACHE_CONFIG_KEY, JSON.stringify(cacheSettings));

                    case 18:

                        configLoaded = true;

                    case 19:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, _this);
    }));

    return function configure() {
        return _ref12.apply(this, arguments);
    };
}();

var clearAllCache = function () {
    var _ref13 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context13.prev = 3;

                        for (_iterator = cacheSettings.cacheKeys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            key = _step.value;

                            clearCache(key);
                        }

                        _context13.next = 11;
                        break;

                    case 7:
                        _context13.prev = 7;
                        _context13.t0 = _context13['catch'](3);
                        _didIteratorError = true;
                        _iteratorError = _context13.t0;

                    case 11:
                        _context13.prev = 11;
                        _context13.prev = 12;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 14:
                        _context13.prev = 14;

                        if (!_didIteratorError) {
                            _context13.next = 17;
                            break;
                        }

                        throw _iteratorError;

                    case 17:
                        return _context13.finish(14);

                    case 18:
                        return _context13.finish(11);

                    case 19:
                        cacheSettings.cacheKeys = [];
                        _context13.next = 22;
                        return setPermanentMethod(CACHE_CONFIG_KEY, JSON.stringify(cacheSettings));

                    case 22:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }));

    return function clearAllCache() {
        return _ref13.apply(this, arguments);
    };
}();

var addKeyToIndex = function () {
    var _ref14 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(key, isPermanentStorage) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        if (!isPermanentStorage) {
                            key = key + SESSION_KEY;
                        }

                        if (!cacheSettings.cacheKeys.includes(key)) {
                            _context14.next = 3;
                            break;
                        }

                        return _context14.abrupt('return');

                    case 3:

                        cacheSettings.cacheKeys.push(key);

                        _context14.next = 6;
                        return setPermanentMethod(CACHE_CONFIG_KEY, JSON.stringify(cacheSettings));

                    case 6:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, _this);
    }));

    return function addKeyToIndex(_x18, _x19) {
        return _ref14.apply(this, arguments);
    };
}();

var saveCache = function () {
    var _ref15 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(key, data) {
        var isPermanentStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var cacheItem;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.next = 2;
                        return configure();

                    case 2:
                        if (configLoaded) {
                            _context15.next = 5;
                            break;
                        }

                        DuLogger.error(LOG_KEY + 'Config not able to load, please fix the config!');
                        return _context15.abrupt('return', false);

                    case 5:
                        cacheItem = {
                            time: Date.now(),
                            data: data
                        };


                        addKeyToIndex(key, isPermanentStorage);

                        if (!isPermanentStorage) {
                            _context15.next = 12;
                            break;
                        }

                        _context15.next = 10;
                        return setPermanentMethod(key, JSON.stringify(cacheItem));

                    case 10:
                        _context15.next = 14;
                        break;

                    case 12:
                        _context15.next = 14;
                        return setTemporaryMethod(key, JSON.stringify(cacheItem));

                    case 14:
                        return _context15.abrupt('return', true);

                    case 15:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, _this);
    }));

    return function saveCache(_x20, _x21) {
        return _ref15.apply(this, arguments);
    };
}();

var clearCache = function () {
    var _ref16 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(key) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        _context16.next = 2;
                        return configure();

                    case 2:
                        if (configLoaded) {
                            _context16.next = 5;
                            break;
                        }

                        DuLogger.error(LOG_KEY + 'Config not able to load, please fix the config!');
                        return _context16.abrupt('return');

                    case 5:
                        if (!key.includes(SESSION_KEY)) {
                            _context16.next = 11;
                            break;
                        }

                        key = key.replace(SESSION_KEY, '');
                        _context16.next = 9;
                        return deleteTemporaryMethod(key);

                    case 9:
                        _context16.next = 13;
                        break;

                    case 11:
                        _context16.next = 13;
                        return deletePermanentMethod(key);

                    case 13:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, _this);
    }));

    return function clearCache(_x23) {
        return _ref16.apply(this, arguments);
    };
}();

var checkCache = function () {
    var _ref17 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(key, lifespanOverrideInMilliseconds, useGracePeriod) {
        var isPermanentStorage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var cacheItem, timeDifference, lifespan;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return configure();

                    case 2:
                        if (configLoaded) {
                            _context17.next = 5;
                            break;
                        }

                        DuLogger.error(LOG_KEY + 'Config not able to load, please fix the config!');
                        return _context17.abrupt('return', false);

                    case 5:
                        if (!isPermanentStorage) {
                            _context17.next = 11;
                            break;
                        }

                        _context17.next = 8;
                        return readPermanentMethod(key);

                    case 8:
                        _context17.t0 = _context17.sent;
                        _context17.next = 14;
                        break;

                    case 11:
                        _context17.next = 13;
                        return readTemporaryMethod(key);

                    case 13:
                        _context17.t0 = _context17.sent;

                    case 14:
                        cacheItem = _context17.t0;

                        if (cacheItem) {
                            _context17.next = 17;
                            break;
                        }

                        return _context17.abrupt('return', false);

                    case 17:

                        cacheItem = JSON.parse(cacheItem);

                        if (cacheItem) {
                            _context17.next = 21;
                            break;
                        }

                        clearCache(key);

                        return _context17.abrupt('return', false);

                    case 21:
                        timeDifference = Date.now() - cacheItem.time;
                        lifespan = lifespanOverrideInMilliseconds > 0 ? lifespanOverrideInMilliseconds : cacheSettings.lifespanInMilliseconds;

                        if (!(timeDifference > lifespan + (useGracePeriod ? 10000 : 0))) {
                            _context17.next = 26;
                            break;
                        }

                        clearCache(key);

                        return _context17.abrupt('return', false);

                    case 26:
                        return _context17.abrupt('return', true);

                    case 27:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, _this);
    }));

    return function checkCache(_x24, _x25, _x26) {
        return _ref17.apply(this, arguments);
    };
}();

var getCache = function () {
    var _ref18 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(key, lifespanOverrideInMilliseconds) {
        var isPermanentStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        _context18.next = 2;
                        return checkCache(key, lifespanOverrideInMilliseconds, true, isPermanentStorage);

                    case 2:
                        if (!_context18.sent) {
                            _context18.next = 15;
                            break;
                        }

                        _context18.t0 = JSON;

                        if (!isPermanentStorage) {
                            _context18.next = 10;
                            break;
                        }

                        _context18.next = 7;
                        return readPermanentMethod(key);

                    case 7:
                        _context18.t1 = _context18.sent;
                        _context18.next = 13;
                        break;

                    case 10:
                        _context18.next = 12;
                        return readTemporaryMethod(key);

                    case 12:
                        _context18.t1 = _context18.sent;

                    case 13:
                        _context18.t2 = _context18.t1;
                        return _context18.abrupt('return', _context18.t0.parse.call(_context18.t0, _context18.t2).data);

                    case 15:
                        return _context18.abrupt('return', null);

                    case 16:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, _this);
    }));

    return function getCache(_x28, _x29) {
        return _ref18.apply(this, arguments);
    };
}();

var DuCache = {
    Setup: setupCache,
    Save: saveCache,
    Clear: clearCache,
    Check: checkCache,
    Get: getCache
};

var LANGUAGES = [{ name: 'English', code: 'en' }, { name: 'Español', code: 'es' }, { name: '汉语', code: 'zh-CN' }, { name: 'Français', code: 'fr' }];

// [English, Spanish, Chinese, French]
var COMMON_TRANSLATIONS = {
    buttons: {
        okay: ['Okay', 'Bueno'],
        yes: ['Yes', 'Si'],
        no: ['No', 'No'],
        cancel: ['Cancel', 'Cancelar'],
        continue: ['Continue', 'Seguir'],
        back: ['Back', 'Regresa'],
        oops: ['Oops, Just Kidding', 'Vaya, es broma'],
        submit: ['Submit', 'Enviar'],
        abort: ['Abort', 'Abortar'],
        agree: ['Agree', 'Acordar'],
        add: ['Add', 'Añadir'],
        delete: ['Delete', 'Eliminar'],
        download: ['Download', 'Descargar'],
        save: ['Save', 'Salvar'],
        accept: ['Accept', 'Aceptar']
    },
    fields: {
        requiredField: ['This field is required', 'Este campo es requerido']
    },
    roles: {
        admin: ['Admin', 'Admin'],
        user: ['User', 'Usuario'],
        readOnly: ['Read Only', 'Solo Lectura']
    }
};

var DuCommonTranslations = { COMMON_TRANSLATIONS: COMMON_TRANSLATIONS, LANGUAGES: LANGUAGES };

var DATE_FORMAT = 'MMM-dd-yyyy';
var DATE_TIME_FORMAT = 'MMM-dd-yyyy hh:mm a';
var DATE_TIME_SECONDS_FORMAT = 'MMM-dd-yyyy hh:mm:ss a';
var ISO_DATE_FORMAT = 'yyyy-MM-dd';
var NULL_TIME = 'T00:00:00';

/* To explain the terms in the formula, the Javascript timestamp has milliseconds (*1000) 
which accounts for the 1000. There are 60*60*24 seconds in one day = 86400. Finally, 
Excel dates start on Jan 1 1900, and Javascript starts on Jan 1 1970. 
There are 25567 days between Jan 1 1900 and Jan 1 1970. */
var EXCEL_DAYS_DIFFERENCE = 25568;

var getWeekNumber = function getWeekNumber(date) {
    var firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    var pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

var toString = function toString(date) {
    var showTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (date !== null) {
        return dateFns.format(date, showTime ? DATE_TIME_FORMAT : DATE_FORMAT);
    } else {
        return null;
    }
};

var formatDateFromIso = function formatDateFromIso(date) {
    var failPlaceholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'N/A';

    if (!!date && (date || '').length > 0) {
        try {
            var dateFixed = date.toString().trim();

            //Fixing date to have a T instead of a space that are correct in some ISO 8601
            if (!dateFixed.includes('T') && dateFixed.includes(' ')) {
                dateFixed = dateFixed.replace(' ', 'T');
            }

            //All dates should be coming in as UTC (Zulu)
            //   except for those that have the null time which allows us to see dates only irregardless of time zone.
            if (!dateFixed.includes(NULL_TIME) && !dateFixed.includes('Z') && dateFixed.includes('T')) {
                dateFixed += 'Z';
            }

            var parsedIso = dateFns.parseISO(dateFixed);

            return dateFns.format(parsedIso, DATE_FORMAT);
        } catch (error) {
            console.error('Got an incorrect date format');

            return failPlaceholder;
        }
    } else {
        return failPlaceholder;
    }
};

var formatDateTimeFromIso = function formatDateTimeFromIso(date) {
    var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var failPlaceholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'N/A';

    if (!!date && (date || '').length > 0) {
        try {
            var dateFixed = date.toString().trim();

            //Fixing date to have a T instead of a space that are correct in some ISO 8601
            if (!dateFixed.includes('T') && dateFixed.includes(' ')) {
                dateFixed = dateFixed.replace(' ', 'T');
            }

            //All dates should be coming in as UTC (Zulu)
            if (!dateFixed.includes('Z') && dateFixed.includes('T')) {
                dateFixed += 'Z';
            }

            var parsedIso = dateFns.parseISO(dateFixed);

            return dateFns.format(parsedIso, showSeconds ? DATE_TIME_SECONDS_FORMAT : DATE_TIME_FORMAT);
        } catch (error) {
            console.error('Got an incorrect date format');

            return failPlaceholder;
        }
    } else {
        return failPlaceholder;
    }
};

var DuDateUtilities = {
    ToString: toString,
    ToPrettyDate: function ToPrettyDate(value) {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return toString(value);
        }

        if (typeof value === 'string') {
            if (value.indexOf('-') === 3) {
                //Pretty Format
                if (value.indexOf(' ')) {
                    //Remove time component
                    return value.split(' ')[0];
                }
                return value;
            }

            if (value.indexOf('-') === 4) {
                //ISO Format
                return formatDateFromIso(value);
            }
        }

        return null;
    },
    ToPrettyDateTime: function ToPrettyDateTime(value) {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return toString(value, true);
        }

        if (typeof value === 'string') {
            if (value.indexOf('-') === 3) {
                //Pretty Format
                return value;
            }

            if (value.indexOf('-') === 4) {
                //ISO Format
                return formatDateTimeFromIso(value);
            }
        }

        return null;
    },
    FormatDateFromIso: formatDateFromIso,
    FormatDateTimeFromIso: formatDateTimeFromIso,
    ToIsoDate: function ToIsoDate(date) {
        var addNullTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var failPlaceholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'N/A';

        try {
            var isoDate = dateFns.format(date, ISO_DATE_FORMAT);

            return isoDate + (addNullTime ? NULL_TIME : '');
        } catch (error) {
            console.error('Got an incorrect date to be able to ISO format');

            return failPlaceholder;
        }
    },
    GetWeekNumber: getWeekNumber,
    GetPoolWeek: function GetPoolWeek(date) {
        return date.getFullYear().toString().substring(2) + ('0' + getWeekNumber(date).toString()).slice(-2);
    },
    TimeSpanToString: function TimeSpanToString(start, end) {
        var difference = end - start;

        if (difference > 1000) {
            difference /= 1000;

            if (difference > 60) {
                difference /= 60;

                if (difference > 60) {
                    return (difference / 60).toFixed(2) + ' h';
                }

                return difference.toFixed(2) + ' min';
            }

            return difference.toFixed(2) + ' s';
        }

        return difference + ' ms';
    },
    getDateFromExcelTimeStamp: function getDateFromExcelTimeStamp(excelDateTimeValue) {
        if (!excelDateTimeValue) {
            return '';
        }

        var jsDateTimeStamp = new Date(Math.round((excelDateTimeValue - EXCEL_DAYS_DIFFERENCE) * 86400 * 1000));
        return this.ToIsoDate(jsDateTimeStamp, '').split('T')[0];
    },
    EXCEL_DAYS_DIFFERENCE: EXCEL_DAYS_DIFFERENCE
};

var _this$1 = undefined;

var writeExcelFile = function writeExcelFile(filename, columns, data) {
    var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "Driscoll's";

    //TODO: We need to add validation

    //TODO: We need to add styling ability

    var dataToSave = [columns.map(function (c) {
        if (typeof c.name === 'string') {
            return c.name;
        }
        return (c.name.props || [])['tipText'];
    })];

    data.forEach(function (d) {
        var row = columns.map(function (c) {
            return d[c.key];
        });
        dataToSave.push(row);
    });

    var worksheet = XLSX.utils.aoa_to_sheet(dataToSave);
    var new_workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(new_workbook, worksheet, name);
    XLSX.writeFile(new_workbook, filename);
};

var handleExcelDrop = function handleExcelDrop(e, returnFunction, statusFunction) {
    e.preventDefault();
    e.stopPropagation();

    var files = e.dataTransfer.files,
        f = files[0];

    readExcelFile(f, returnFunction, statusFunction);
};

var createExcelDrop = function createExcelDrop(element, returnFunction, statusFunction) {
    element.addEventListener('drop', function (e) {
        handleExcelDrop(e, returnFunction, statusFunction);
    }, false);
};

var handleFiles = function handleFiles(fileList, returnFunction, statusFunction) {
    if (!fileList || fileList.length <= 0) {
        return;
    }

    var f = fileList[0];
    readExcelFile(f, returnFunction, statusFunction);
};

var readExcelFile = function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, returnFunction, statusFunction) {
        var startTime, reader, extension;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        startTime = new Date();
                        reader = new FileReader();
                        extension = file.name.lastIndexOf('.') > 0 ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';

                        if (!(extension !== 'xlsx' && extension !== 'xls' && extension !== 'xlsb')) {
                            _context.next = 6;
                            break;
                        }

                        returnFunction(null, { fileName: file.name, msElapsed: 0, timeElapsed: 'Failed', message: 'File Extension is not valid, please upload an excel document.' });
                        return _context.abrupt('return');

                    case 6:

                        setStatus(statusFunction, -1, 'Starting to Open Excel File');

                        reader.onload = function (e) {
                            setStatus(statusFunction, -1, 'Excel File Open, ready to parse');
                            var data = new Uint8Array(e.target.result);
                            var workbook = XLSX.read(data, { type: 'array' });
                            setStatus(statusFunction, -1, 'Excel File Parsed');
                            var endTime = new Date();

                            returnFunction(workbook, { fileName: file.name, msElapsed: endTime - startTime, timeElapsed: DuDateUtilities.TimeSpanToString(startTime, endTime) });
                        };

                        reader.readAsArrayBuffer(file);

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this$1);
    }));

    return function readExcelFile(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();

var readRows = function () {
    var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(workbook, sheetName, statusFunction) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', new Promise(function (resolve) {
                            var rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: "" });
                            resolve(rows);
                        }));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this$1);
    }));

    return function readRows(_x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
    };
}();

var setStatus = function () {
    var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(statusFunction, percentDone, message) {
        var isIndeterminate;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        isIndeterminate = percentDone < 0;

                        statusFunction({ isIndeterminate: isIndeterminate, percentDone: percentDone, message: message });

                    case 2:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this$1);
    }));

    return function setStatus(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
    };
}();

var getRow = function getRow(data, sheetName, row, columnStart, columnEnd) {
    var sheet = data[sheetName];

    if (!sheet) {
        return [];
    }

    var row = [];
    var sheetKeys = Object.keys(sheet);

    for (var i = columnStart; i <= columnEnd; i++) {
        var cellKey = '' + i + row;
        if (!sheetKeys.includes(cellKey)) {
            continue;
        }

        row.push(sheet[cellKey]);
    }
};

/*
   TODO: Add following functions to support excel import more easily
   GetRows(data, sheetName, startRow, endRow, columnStart, columnEnd);
   GetRow(data, sheetName, row, columnStart, columnEnd);
   GetCell(data, sheetName, row, column);
   GetColumn(data, sheetName, columnStart, columnEnd, row);

   GetRowsWithTemplate(data, sheetName, template, startRow, endRow, columnStart, columnEnd);
   GetRowWithTemplate(data, sheetName, template, row, columnStart, columnEnd);
   GetColumnWithTemplate(data, sheetName, template, columnStart, columnEnd, row);
*/

var DuExcelUtilities = {
    Write: writeExcelFile,
    Read: readExcelFile,
    HandleFiles: handleFiles,
    CreateExcelDrop: createExcelDrop,
    GetRow: getRow,
    ReadRows: readRows
};

var glossary = [];

var addAll = function addAll(glossaryList) {
    glossary = glossaryList;
};

var addOne = function addOne(key, shortDescription, longDescription) {
    if (getGlossaryObject(key) !== null) {
        var index = glossary.findIndex(function (glossaryObj) {
            return glossaryObj.key === key;
        });

        glossary.splice(index, 1);
    }

    glossary.push({ key: key, shortDescription: shortDescription, longDescription: longDescription });
};

var getList = function getList() {
    return glossary.map(function (glossaryObj) {
        return { key: glossaryObj.key, value: glossaryObj.longDescription };
    });
};

var getGlossaryObject = function getGlossaryObject(key) {
    var item = glossary.find(function (glossaryObj) {
        return glossaryObj.key === key;
    });

    return item ? item : null;
};

var getDescription = function getDescription(key) {
    var shortDescription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var glossaryObject = getGlossaryObject(key);

    if (glossaryObject !== null) {
        return shortDescription ? glossaryObject.shortDescription : glossaryObject.longDescription;
    }

    return '';
};

var DuGlossaryUtilities = {
    Glossary: glossary,
    AddAll: addAll,
    AddOne: addOne,
    //Get: get,
    GetDescription: getDescription,
    //GetGlossaryList: getGlossaryList
    GetList: getList
};

var iconUtilities = {
    GetBerryLabel: function GetBerryLabel(berryType) {
        switch (berryType) {
            case 1:
            case '1':
            case 'BLACK':
                return 'Blackberry';
            case 2:
            case '2':
            case 'BLUE':
                return 'Blueberry';
            case 3:
            case '3':
            case 'RASP':
                return 'Raspberry';
            case 4:
            case '4':
            case 'STRAW':
                return 'Strawberry';
            default:
                return 'Unknown';
        }
    }
};

var icons = {
    Black_Small_Png: require('./Images/Black_Small.png'),
    Blue_Small_Png: require('./Images/Blue_Small.png'),
    Rasp_Small_Png: require('./Images/Rasp_Small.png'),
    Straw_Small_Png: require('./Images/Straw_Small.png'),
    Black_Medium_Png: require('./Images/Black_Medium.png'),
    Blue_Medium_Png: require('./Images/Blue_Medium.png'),
    Rasp_Medium_Png: require('./Images/Rasp_Medium.png'),
    Straw_Medium_Png: require('./Images/Straw_Medium.png')
};

var LOGGING_AFFIX = 'Personalization Utilities:: ';

/**
 * @param {string} variable Variable for which personalization setting we want to get from the server object
 * @param {object} data The personalization object from the server
 * @return {object} Personalization object for the UI for a given variable
 */
var getPersonalization = function getPersonalization(variable, data) {
    if (!data) {
        console.error(LOGGING_AFFIX + 'No Data found');
        return null;
    }

    var keys = Object.keys(data);

    if (keys.length <= 0 || !keys.includes(variable)) {
        console.error(LOGGING_AFFIX + 'No Data found for (' + variable + ')');
        return null;
    }

    var result = null;

    try {
        result = JSON.parse(data[variable]);
    } catch (err) {
        console.error(LOGGING_AFFIX + 'Unable to parse for ' + variable);
    }

    return result;
};

var verifyVariableMappings = function verifyVariableMappings(variableMappings) {
    if (!Array.isArray(variableMappings)) {
        return false;
    }

    if (variableMappings.some(function (map) {
        if (!map) {
            return true;
        }

        var keys = Object.keys(map);

        if (!keys.includes('key') && !keys.includes('value')) {
            return true;
        }

        return false;
    })) {
        return false;
    }

    return true;
};

/**
 * @param {object} data The personalization object from the server
 * @param {list} variableMappings Mappings between key and value, where key is the variable within the personalizations and the value is the value to have for the server i.e. [{key: 'localVariable', value:'serverVariable'}].
 * @return {object} Personalization objects for the UI
 */
var getAllPersonalizations = function getAllPersonalizations(data, variableMappings) {
    if (!data) {
        console.error(LOGGING_AFFIX + 'No Data found');
        return null;
    }

    var keys = Object.keys(data);

    if (keys.length <= 0) {
        console.error(LOGGING_AFFIX + 'No Data found to personalize');
        return null;
    }

    if (!verifyVariableMappings(variableMappings)) {
        console.error(LOGGING_AFFIX + 'Variable Mappings are not correctly formatted');
        return null;
    }

    var result = {};

    variableMappings.each(function (map) {
        var personalization = getPersonalization(map.value, data);

        if (personalization !== null) {
            result[map.key] = personalization;
        }
    });

    return result;
};

/**
 * @param {object} personalizations Personalization object with all of the personalizations we want to send to the server.
 * @param {list} variableMappings Mappings between key and value, where key is the variable within the personalizations and the value is the value to have for the server i.e. [{key: 'localVariable', value:'serverVariable'}].
 * @return {object} Personalization object for the server
 */
var setPersonalizations = function setPersonalizations(personalizations, variableMappings) {
    if (!personalizations) {
        console.error(LOGGING_AFFIX + 'No Data found');
        return null;
    }

    var keys = Object.keys(personalizations);

    if (keys.length <= 0) {
        console.error(LOGGING_AFFIX + 'No Data found to personalize');
        return null;
    }

    var result = {};

    variableMappings.each(function (map) {
        if (!personalizations[map.key]) {
            console.warning(LOGGING_AFFIX + 'Missing data for sending to server: ' + map.value);
            return;
        }

        result[map.value] = JSON.stringify(personalizations[map.key]);
    });

    return result;
};

var DuPersonalizationUtilities = {
    GetPersonalization: getPersonalization,
    GetAllPersonalizations: getAllPersonalizations,
    SetPersonalizations: setPersonalizations
};

var convertHslToHex = function convertHslToHex(hsl) {
    var hslAr = hsl.split(',');

    if (hslAr.length < 3) {
        return '#000';
    }

    var h = Number(hslAr[0].substr(hslAr[0].indexOf('(') + 1));
    var s = Number(hslAr[1].replace('%', ''));
    var l = Number(hslAr[2].replace('%', '').replace(')', ''));

    s /= 100;
    l /= 100;

    var c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs(h / 60 % 2 - 1)),
        m = l - c / 2,
        r = 0,
        g = 0,
        b = 0;

    if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
    }

    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length == 1) {
        r = '0' + r;
    }

    if (g.length == 1) {
        g = '0' + g;
    }

    if (b.length == 1) {
        b = '0' + b;
    }

    return '#' + r + g + b;
};

var convertHexToHsl = function convertHexToHsl(H) {
    // Convert hex to RGB first
    var r = 0,
        g = 0,
        b = 0;
    if (H.length == 4) {
        r = '0x' + H[1] + H[1];
        g = '0x' + H[2] + H[2];
        b = '0x' + H[3] + H[3];
    } else if (H.length == 7) {
        r = '0x' + H[1] + H[2];
        g = '0x' + H[3] + H[4];
        b = '0x' + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;

    var cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

    if (delta == 0) {
        h = 0;
    } else if (cmax == r) {
        h = (g - b) / delta % 6;
    } else if (cmax == g) {
        h = (b - r) / delta + 2;
    } else {
        h = (r - g) / delta + 4;
    }

    h = Math.round(h * 60);

    if (h < 0) {
        h += 360;
    }

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
};

var updateHslBrightness = function updateHslBrightness(hsl, addition) {
    var currentHslPartA = hsl.substr(0, hsl.lastIndexOf(',') + 1);
    var currentHslPartB = hsl.substr(hsl.lastIndexOf('%'));
    var currentHslBrightness = Number(hsl.substr(hsl.lastIndexOf(',') + 1, hsl.lastIndexOf('%') - hsl.lastIndexOf(',') - 1));

    return currentHslPartA + Math.max(0, Math.min(100, currentHslBrightness + addition)) + currentHslPartB;
};

var setHslBrightness = function setHslBrightness(hsl, brightness) {
    var currentHslPartA = hsl.substr(0, hsl.lastIndexOf(',') + 1);
    var currentHslPartB = hsl.substr(hsl.lastIndexOf('%'));

    return currentHslPartA + Math.max(0, Math.min(100, brightness)) + currentHslPartB;
};

var updateHslSaturation = function updateHslSaturation(hsl, addition) {
    var currentHslPartA = hsl.substr(0, hsl.indexOf(',') + 1);
    var currentHslPartB = hsl.substr(hsl.indexOf('%'));
    var currentHslSaturation = Number(hsl.substr(hsl.indexOf(',') + 1, hsl.indexOf('%') - hsl.indexOf(',') - 1));

    return currentHslPartA + Math.max(0, Math.min(100, currentHslSaturation + addition)) + currentHslPartB;
};

var setHslSaturation = function setHslSaturation(hsl, saturation) {
    var currentHslPartA = hsl.substr(0, hsl.indexOf(',') + 1);
    var currentHslPartB = hsl.substr(hsl.indexOf('%'));

    return currentHslPartA + Math.max(0, Math.min(100, saturation)) + currentHslPartB;
};

var updateHslOpacity = function updateHslOpacity(hsl, opacity) {
    var hslParts = hsl.split(',');
    if (hslParts.length < 3) {
        return hsl;
    }

    if (opacity > 1) {
        opacity /= 100;
    }

    return (hslParts.length > 3 ? hslParts[0] : hslParts[0].replace('hsl', 'hsla')) + ',' + hslParts[1] + ',' + hslParts[2].replace(')', '') + ',' + opacity.toFixed(2) + ')';
};

var defaultColors = {
    primary: {
        green: '#4a773c',
        red: '#da291c',
        pink: '#c63663',
        purple: '#6f5091',
        blue: '#0076a5',
        yellow: '#fdda24'
    },
    secondary: {
        error: {
            light: '#c54',
            dark: '#400'
        },
        warning: {
            light: '#fe9',
            dark: '#971'
        }
    },
    text: {
        black: {
            main: '#222',
            light: '#444',
            dark: '#000'
        },
        white: {
            main: '#eee',
            light: '#fff',
            dark: '#ddd'
        }
    }
};

var defaultFontFamily = ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',');

var roboto = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    src: 'src: local(\'Roboto\'), local(\'Roboto-Regular\'), url(/Roboto_Ext.woff2) format(\'woff2\');',
    unicodeRange: 'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;'
};

var createSimpleThemeConfig = function createSimpleThemeConfig(lightPrimary, darkPrimary) {
    var isDarkTheme = window && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)').matches : false;
    var isHsl = lightPrimary.indexOf('hsl') >= 0;

    if (!darkPrimary) {
        darkPrimary = lightPrimary;
    }

    //Light Color HSL Values
    var lightPrimaryHsl = isHsl ? lightPrimary : convertHexToHsl(lightPrimary);
    var lightPrimaryHslLight = updateHslBrightness(lightPrimaryHsl, 10);
    var lightPrimaryHslDark = updateHslBrightness(lightPrimaryHsl, -10);

    //Light Color Hex Values
    var lightPrimaryHex = isHsl ? convertHslToHex(lightPrimaryHsl) : lightPrimary;
    var lightPrimaryHexLight = convertHslToHex(lightPrimaryHslLight);
    var lightPrimaryHexDark = convertHslToHex(lightPrimaryHslDark);

    //Dark Colors HSL Values
    var darkPrimaryHsl = isHsl ? darkPrimary : convertHexToHsl(darkPrimary);
    var darkPrimaryHslLight = updateHslBrightness(darkPrimaryHsl, 10);
    var darkPrimaryHslDark = updateHslBrightness(darkPrimaryHsl, -10);

    //Dark Colors Hex Values
    var darkPrimaryHex = isHsl ? convertHslToHex(darkPrimaryHsl) : darkPrimary;
    var darkPrimaryHexLight = convertHslToHex(darkPrimaryHslLight);
    var darkPrimaryHexDark = convertHslToHex(darkPrimaryHslDark);

    currentTheme = {
        palette: {
            type: isDarkTheme ? 'dark' : 'light',
            primary: {
                light: isDarkTheme ? darkPrimaryHexLight : lightPrimaryHexLight,
                main: isDarkTheme ? darkPrimaryHex : lightPrimaryHex,
                dark: isDarkTheme ? darkPrimaryHexDark : lightPrimaryHexDark,
                contrastText: defaultColors.text.white.main
            },
            secondary: {
                light: defaultColors.secondary.error.light,
                main: defaultColors.secondary.error.light,
                dark: defaultColors.secondary.error.dark,
                contrastText: defaultColors.text.white.main
            },
            error: {
                light: defaultColors.secondary.error.light,
                main: defaultColors.secondary.error.light,
                dark: defaultColors.secondary.error.dark,
                contrastText: defaultColors.text.white.main
            }
        },
        typography: {
            fontFamily: defaultFontFamily
        },
        light: {
            body: defaultColors.text.white.main,
            primary: defaultColors.text.white.light,
            secondary: defaultColors.text.white.main,
            transparent: '#333C',
            error: defaultColors.secondary.error.light,
            warning: defaultColors.secondary.warning.light,
            buttonBorder: '#bbb',
            text: {
                primary: defaultColors.text.black.main,
                secondary: defaultColors.text.black.light,
                inverted: defaultColors.text.white.light,
                disabled: defaultColors.text.black.light,
                error: defaultColors.text.black.dark,
                errorTitle: defaultColors.secondary.error.light,
                variant: {
                    primary: defaultColors.text.white.light,
                    secondary: defaultColors.text.white.dark
                }
            },
            accent: {
                primary: lightPrimaryHex,
                secondary: lightPrimaryHexLight,
                brightness: function brightness(percent) {
                    return updateHslBrightness(lightPrimaryHsl, percent);
                },
                opacity: function opacity(_opacity) {
                    return updateHslOpacity(lightPrimaryHsl, _opacity);
                },
                text: {
                    primary: lightPrimaryHex
                }
            },
            variant: {
                primary: defaultColors.text.black.dark,
                secondary: defaultColors.text.black.main
            },
            border: {
                middle: '#8888'
            },
            grid: {
                color1: setHslBrightness(lightPrimaryHsl, 97),
                color2: setHslBrightness(setHslSaturation(lightPrimaryHsl, 30), 80),
                color3: setHslBrightness(updateHslSaturation(lightPrimaryHsl, -20), 75),
                hover: defaultColors.text.white.dark,
                even: defaultColors.text.white.light,
                odd: defaultColors.text.white.main
            },
            header: {
                color1: 'hsla(0, 0%, 95%)',
                color2: 'hsla(0, 0%, 90%)',
                color3: 'hsla(0, 0%, 75%)',
                shadow: 'hsl(0, 0%, 60%)'
            },
            shadow: ['9px 9px 16px ' + updateHslOpacity(updateHslSaturation(lightPrimaryHsl, -20), 0.3), '-9px -9px 16px ' + updateHslOpacity(updateHslSaturation(lightPrimaryHsl, -20), 0.1), '0 0 8px ' + updateHslOpacity(lightPrimaryHsl, 0.5), '0 0 8px ' + updateHslOpacity(lightPrimaryHsl, 0.25)]
        },
        dark: {
            body: defaultColors.text.black.main,
            primary: defaultColors.text.black.dark,
            secondary: defaultColors.text.black.main,
            transparent: '#3338',
            error: defaultColors.secondary.error.dark,
            warning: defaultColors.secondary.warning.dark,
            buttonBorder: '#555555',
            text: {
                primary: defaultColors.text.white.main,
                secondary: defaultColors.text.white.light,
                inverted: defaultColors.text.black.main,
                disabled: '#888',
                error: defaultColors.text.white.dark,
                errorTitle: defaultColors.secondary.error.light,
                variant: {
                    primary: defaultColors.text.black.dark,
                    secondary: defaultColors.text.black.main
                }
            },
            accent: {
                primary: lightPrimaryHex,
                secondary: lightPrimaryHexLight,
                brightness: function brightness(percent) {
                    return updateHslBrightness(darkPrimaryHsl, percent);
                },
                opacity: function opacity(_opacity2) {
                    return updateHslOpacity(darkPrimaryHsl, _opacity2);
                },
                text: {
                    primary: lightPrimaryHex
                }
            },
            variant: {
                primary: defaultColors.text.white.light,
                secondary: defaultColors.text.white.dark
            },
            border: {
                middle: '#8888'
            },
            grid: {
                color1: '#171817',
                color2: '#3d403d',
                color3: '#464646',
                hover: defaultColors.text.black.light,
                even: '#151515',
                odd: defaultColors.text.black.main
            },
            header: {
                color1: 'hsla(0, 0%, 20%)',
                color2: 'hsla(0, 0%, 15%)',
                color3: 'hsla(0, 0%, 16%)',
                shadow: 'hsl(0, 0%, 33%)'
            },
            shadow: ['9px 9px 16px ' + updateHslOpacity(updateHslSaturation(darkPrimaryHsl, -20), 0.3), '-9px -9px 16px ' + updateHslOpacity(updateHslSaturation(darkPrimaryHsl, -20), 0.1), '0 0 8px ' + updateHslOpacity(darkPrimaryHsl, 0.5), '0 0 8px ' + updateHslOpacity(darkPrimaryHsl, 0.25)]
        },
        darkTheme: '@media (prefers-color-scheme: dark)',
        important: '!important',
        overrides: {
            MuiCssBaseline: {
                '@global': {
                    '@font-face': [roboto]
                }
            }
        }
    };

    return currentTheme;
};

var currentTheme = createSimpleThemeConfig(defaultColors.primary.green);

var buttonThemes = {
    Standard: 0,
    Polymorphism: 1,
    Hard: 2,
    BottomLine: 4
};

var currentBtnTheme = buttonThemes.Standard;
var currentButtonTheme = function currentButtonTheme() {
    return currentBtnTheme;
};

var registerTheme = function registerTheme(theme) {
    currentBtnTheme = theme;
};

var validButtonTheme = function validButtonTheme(theme) {
    if (theme & buttonThemes.Polymorphism) {
        return !(theme & buttonThemes.Hard);
    }

    return true;
};

var hasTheme = function hasTheme(themeA, themeB) {
    return (themeA & themeB) > 0;
};

var DuThemeUtilities = {
    CurrentTheme: currentTheme,
    CreateSimpleThemeConfig: createSimpleThemeConfig,
    ConvertHslToHex: convertHslToHex,
    ConvertHexToHsl: convertHexToHsl,
    UpdateHslBrightness: updateHslBrightness,
    UpdateHslOpacity: updateHslOpacity,
    SetHslBrightness: setHslBrightness,
    SetHslSaturation: setHslSaturation,
    DefaultColors: defaultColors,
    ButtonThemes: buttonThemes,
    CurrentButtonTheme: currentButtonTheme,
    RegisterTheme: registerTheme,
    ValidButtonTheme: validButtonTheme,
    HasTheme: hasTheme
};

var _this$2 = undefined;

var createFileDrop = function createFileDrop(element, returnFunction, statusFunction, acceptedFiles) {
    element.addEventListener('drop', function (e) {
        handleFileDrop(e, returnFunction, statusFunction, acceptedFiles);
    }, false);
};

var handleFileDrop = function handleFileDrop(e, returnFunction, statusFunction, acceptedFiles) {
    e.preventDefault();
    e.stopPropagation();

    var files = e.dataTransfer.files,
        f = files[0];
    readFile(f, returnFunction, statusFunction, acceptedFiles);
};

var setStatus$1 = function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(statusFunction, percentDone, message) {
        var isIndeterminate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        isIndeterminate = percentDone < 0;

                        statusFunction({ isIndeterminate: isIndeterminate, percentDone: percentDone, message: message });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this$2);
    }));

    return function setStatus(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var handleFiles$1 = function handleFiles(fileList, returnFunction, statusFunction, acceptedFiles) {
    if (!fileList || fileList.length <= 0) {
        return;
    }

    var f = fileList[0];
    readFile(f, returnFunction, statusFunction, acceptedFiles);
};

var readFile = function () {
    var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file, returnFunction, statusFunction, acceptedFiles) {
        var startTime, extension, endTime;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        startTime = new Date();
                        extension = file.name.lastIndexOf('.') > 0 ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';

                        if (acceptedFiles.includes('.' + extension)) {
                            _context2.next = 5;
                            break;
                        }

                        returnFunction(null, { fileName: file.name, msElapsed: 0, timeElapsed: 'Failed', message: 'File Extension is not valid, please upload a document.' });
                        return _context2.abrupt('return');

                    case 5:

                        setStatus$1(statusFunction, -1, 'Starting to Open File');
                        endTime = new Date();


                        returnFunction(file, { fileName: file.name, msElapsed: endTime - startTime, timeElapsed: DuDateUtilities.TimeSpanToString(startTime, endTime) });

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this$2);
    }));

    return function readFile(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
    };
}();

var readRows$1 = function () {
    var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(workbook, sheetName, statusFunction) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        return _context3.abrupt('return', new Promise(function (resolve) {
                            var rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: "" });
                            resolve(rows);
                        }));

                    case 1:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this$2);
    }));

    return function readRows(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
    };
}();

var DuUploadUtilities = {
    CreateFileDrop: createFileDrop,
    ReadRows: readRows$1,
    HandleFiles: handleFiles$1
};

var _this$3 = undefined;

var allowedStringValuesRegex = RegExp(/[.,?\/#!$%\^&\*;:{}=\-_`'"~()]/);
var allowedNumberValuesRegex = RegExp(/^[0-9]+$/);
var allowedIntegerValuesRegex = RegExp(/^[-]?[0-9]*[.]?[0-9]{0,2}$/);
var allowedDecimalValuesRegex = RegExp(/^[-]?[0-9]*[.]?[0-9]*$/);
var allowedAlphaNumericValuesRegex = RegExp(/[a-zA-Z0-9]+$/);
var emailRegex = RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/);
var userIdRegex = RegExp(/^([a-zA-Z0-9_\-]+)\.([a-zA-Z0-9_\-]+)$/);

var isValid = function isValid(element, type) {
    switch (type) {
        case 'number':
            {
                if (!allowedNumberValuesRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'text':
            {
                if (!allowedStringValuesRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'decimal':
            {
                if (!allowedDecimalValuesRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'alphaNumeric':
            {
                if (!allowedAlphaNumericValuesRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'integer':
            {
                if (!allowedIntegerValuesRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'email':
            {
                if (!emailRegex.test(element)) {
                    return false;
                } else return true;
            }
        case 'required':
            {
                if (element === '') {
                    return false;
                } else return true;
            }
        default:
            return false;
    }
};

var validationResultStatus = function validationResultStatus(index, total, errorList, timeStarted) {
    var errorRowCount = ((errorList || []).filter(function (error) {
        return error;
    }) || []).length;
    var errorTotalCount = 0;

    if (errorRowCount > 0) {
        var errorCountList = errorList.map(function (l) {
            return l.errorCount;
        });
        errorTotalCount = errorCountList.reduce(function (a, b) {
            return a + b;
        }, 0);
    }

    return {
        index: index,
        total: total,
        validCount: total - errorRowCount,
        errorRowCount: errorRowCount,
        errorTotalCount: errorTotalCount,
        errorList: errorList || [],
        elapsedTime: DuDateUtilities.TimeSpanToString(timeStarted, new Date())
    };
};

var validationAddError = function validationAddError(errorList, index, funcName, message) {
    if (errorList[index]) {
        errorList[index].errorCount++;
        errorList[index].errors.push({ funcName: funcName, message: message });
    } else {
        errorList[index] = { errorCount: 1, errors: [{ funcName: funcName, message: message }] };
    }
};

var validateData = function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, columns) {
        var statusCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
        var verbose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var statusUpdateEvery = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new Promise(function (resolve, reject) {
                            if (!data || data.length <= 0 || !columns || columns.length <= 0) {
                                reject(validationResultStatus(0, 0, [], new Date()));
                                return;
                            }

                            var startTime = new Date();
                            var errorList = [];

                            for (var i = 0; i < data.length; i++) {
                                validateRow(i, data[i], columns, errorList);

                                if (i % statusUpdateEvery === 0) {
                                    statusCallback(validationResultStatus(i, data.length, verbose ? errorList : [], startTime));
                                }
                            }

                            resolve(validationResultStatus(data.length, data.length, errorList, startTime));
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this$3);
    }));

    return function validateData(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var validateRow = function validateRow(index, row, columns, errorList) {
    for (var i = 0; i < columns.length; i++) {
        if (columns[i].key) {
            validateColumn(index, row[columns[i].key], columns[i], errorList);
        }
    }
};

var validateColumn = function validateColumn(index, data, column, errorList) {
    if (typeof column.validationType === 'string') ; else {
        var validationFuncList = [];
        if (typeof column.validationType === 'function') {
            validationFuncList.push(column.validationType);
        } else if (typeof column.validationType === 'array' && typeof column.validationType[0] === 'function') {
            validationFuncList = column.validationType;
        }

        for (var i = 0; i < validationFuncList.length; i++) {
            var result = validationFuncList[i](data, column.label || column.key, column.params || column.regex);

            if (result !== null && (typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
                validationAddError(errorList, index, result.funcName || 'Unknown Function', result.message || 'Unknown Error');
            }
        }
    }
};

var validateText = function validateText(input, columnName) {
    if (!isValid(input, 'text')) {
        return { funcName: 'Text', message: 'Bad characters provided in column "' + columnName + '"' };
    }
    return null;
};

var validateNumber = function validateNumber(input, columnName, params) {
    if (!isValid(input, 'number')) {
        return { funcName: 'Number', message: 'Bad number provided in column "' + columnName + '"' };
    }

    if (params) {
        var min = (params || {}).min || 0;
        var max = (params || {}).max || 255;

        if (input < min) {
            return { funcName: 'Number', message: 'Number in column "' + columnName + '" is too small' };
        } else if (input > max) {
            return { funcName: 'Number', message: 'Number in column "' + columnName + '" is too large' };
        }
    }

    return null;
};

var validateLength = function validateLength(input, columnName, params) {
    var min = (params || {}).min || 0;
    var max = (params || {}).max || 255;
    var length = input.toString().length;

    if (length < min) {
        return { funcName: 'Column Length', message: 'Data in column "' + columnName + '" is too short' };
    } else if (length > max) {
        return { funcName: 'Column Length', message: 'Data in column "' + columnName + '" is too long' };
    }
    return null;
};

var validateDecimal = function validateDecimal(input, columnName) {
    if (!isValid(input, 'decimal')) {
        return { funcName: 'Decimal', message: 'Bad decimal in column "' + columnName + '"' };
    }
    return null;
};

var validateRegex = function validateRegex(input, columnName, params) {
    var regex = params || '';

    if (!regex.test(input)) {
        return { funcName: 'Regex', message: 'Data in column "' + columnName + '" is not valid' };
    }
    return null;
};

var validateEmail = function validateEmail(input, columnName) {
    if (!isValid(input, 'email')) {
        return { funcName: 'Email', message: 'Bad email in column "' + columnName + '"' };
    }
    return null;
};

var validateDate = function validateDate(input, columnName, params) {
    if (!input instanceof Date) {
        return { funcName: 'Date', message: 'Bad date in column "' + columnName + '"' };
    }

    var minDate = params.minDate || null;
    var maxDate = params.maxDate || null;

    if (minDate !== null && input < minDate) {
        return { funcName: 'Date', message: 'Date in column "' + columnName + '" is too far in the past' };
    } else if (maxDate !== null && input > maxDate) {
        return { funcName: 'Date', message: 'Date in column "' + columnName + '" is too dar in the future' };
    }
    return null;
};

var validateRequired = function validateRequired(input, columnName) {
    if (input === null || input === undefined || input === '') return { funcName: 'List', message: 'Matching data not found in column "' + columnName + '"' };
    return null;
};

var validateDataInList = function validateDataInList(input, columnName, params) {
    var list = params || [];

    var isObjectList = list.length > 0 && list[columnName];

    if (isObjectList && !list[columnName].includes(input)) {
        return { funcName: 'List', message: 'Matching data not found in column "' + columnName + '"' };
    } else if (!list.includes(input)) {
        return { funcName: 'List', message: 'Matching data not found in column "' + columnName + '"' };
    }
    return null;
};

var validateAlphaNumeric = function validateAlphaNumeric(input, columnName) {
    if (!isValid(input, 'alphaNumeric')) {
        return { funcName: 'AlphaNumeric', message: 'Bad characters provided in column "' + columnName + '"' };
    }
    return null;
};

var validateRange = function validateRange() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var columnName = arguments[1];
    var params = arguments[2];

    var inputArr = input.toString().split('-');
    for (var i = 0; i < inputArr.length; i++) {
        if (!isValid(inputArr[i].trim(), 'number')) {
            return { funcName: 'Number', message: 'Bad number provided in column "' + columnName + '"' };
        }
    }if (params) {
        var min = (params || {}).min || 0;
        var max = (params || {}).max || 255;

        if (input < min) {
            return { funcName: 'Number', message: 'Number in column "' + columnName + '" is too small' };
        } else if (input > max) {
            return { funcName: 'Number', message: 'Number in column "' + columnName + '" is too large' };
        }
    }

    return null;
};

var DuValidationUtilities = {
    STRING_REGEXP: allowedStringValuesRegex,
    NUMBER_REGEXP: allowedNumberValuesRegex,
    INTEGER_REGEXP: allowedIntegerValuesRegex,
    DECIMAL_REGEXP: allowedDecimalValuesRegex,
    ALPHA_NUMERIC_REGEXP: allowedAlphaNumericValuesRegex,
    EMAIL_REGEXP: emailRegex,
    USER_ID_REGEX: userIdRegex,
    isValid: isValid,
    ValidateRequired: validateRequired,
    ValidateData: validateData,
    ValidateText: validateText,
    ValidateNumber: validateNumber,
    ValidateLength: validateLength,
    ValidateDecimal: validateDecimal,
    ValidateRegex: validateRegex,
    ValidateEmail: validateEmail,
    ValidateDate: validateDate,
    ValidateDataInList: validateDataInList,
    ValidateAlphaNumeric: validateAlphaNumeric,
    ValidateRange: validateRange
};

//Utilities
//External Libraries
if (window) {
    window.Driscolls_React_Utilities_Version = '2.27.9';
    window.Versions = window.Versions || [];
    if (window.Versions.findIndex(function (v) {
        return v.package === 'driscolls-react-utilities';
    }) < 0) {
        window.Versions.push({
            package: 'driscolls-react-utilities',
            name: "Driscoll's React Utilities",
            description: "Driscoll's React Utilities",
            version: window.Driscolls_React_Utilities_Version
        });
    }
}

exports.DuAuthenticationUtilities = DuAuthenticationUtilities;
exports.DuCache = DuCache;
exports.DuCommonTranslations = DuCommonTranslations;
exports.DuDateUtilities = DuDateUtilities;
exports.DuExcelUtilities = DuExcelUtilities;
exports.DuGlossaryUtilities = DuGlossaryUtilities;
exports.DuIcons = iconUtilities;
exports.DuIconSrc = icons;
exports.DuLogger = DuLogger;
exports.DuPersonalizationUtilities = DuPersonalizationUtilities;
exports.DuThemeUtilities = DuThemeUtilities;
exports.DuUploadUtilities = DuUploadUtilities;
exports.DuValidationUtilities = DuValidationUtilities;
//# sourceMappingURL=index.js.map
